module.exports = __webpack_public_path__ + "static/media/certn-logo-success.dfa06d0e.svg";